module.exports = __webpack_public_path__ + "img/I2C_Fig09.e3317803.png";